"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const useOnLoad_1 = __importDefault(require("../../hooks/useOnLoad"));
const valueIsBoolean_1 = __importDefault(require("../../../typeAssertions/valueIsBoolean"));
const getNumberFromUnknown_1 = __importDefault(require("../../../shared/getNumberFromUnknown"));
const useControlEvents_1 = __importDefault(require("../../../hooks/useControlEvents"));
const controlStyleToAtomStyle_1 = __importDefault(require("../../../shared/controlStyleToAtomStyle"));
const videoStyle = { flex: 1, backgroundColor: 'transparent' };
const VideoViewRender = ({ videoControl, }) => {
    var _a;
    const { Render, getColorFromSpecification, globalFontSize, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const events = (0, useControlEvents_1.default)(videoControl);
    (0, useOnLoad_1.default)(videoControl, events);
    const volume = (0, react_1.useMemo)(() => {
        try {
            const currentVolume = (0, getNumberFromUnknown_1.default)(videoControl === null || videoControl === void 0 ? void 0 : videoControl.volume);
            if (currentVolume >= 0 && currentVolume <= 1) {
                return currentVolume;
            }
            return 1;
        }
        catch (_a) {
            return 1;
        }
    }, [videoControl === null || videoControl === void 0 ? void 0 : videoControl.volume]);
    return (react_1.default.createElement(Render.View, { style: (0, controlStyleToAtomStyle_1.default)({
            getColorFromSpecification,
            globalFontSize,
            style: (_a = videoControl.style) !== null && _a !== void 0 ? _a : {},
        }) },
        react_1.default.createElement(Render.Video, { style: videoStyle, videoConfig: videoControl.videoConfig, paused: videoControl === null || videoControl === void 0 ? void 0 : videoControl.paused, muted: videoControl === null || videoControl === void 0 ? void 0 : videoControl.muted, play: videoControl === null || videoControl === void 0 ? void 0 : videoControl.play, showControls: (0, valueIsBoolean_1.default)(videoControl === null || videoControl === void 0 ? void 0 : videoControl.showControls)
                ? videoControl.showControls : true, volume: volume, onError: events.onError })));
};
exports.default = VideoViewRender;
